import { CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'
import { animations } from './animations'

const getArrowIconsWrapper = (
  carouselWidth: number,
  overrideStyles?: CSSObject
): CSSObject => ({
  cursor: 'default',
  position: 'absolute',
  width: `calc(${carouselWidth}px + 110px)`,
  top: 'calc(50% - 18px)',
  zIndex: 1,
  ...overrideStyles,
  'li.kuiper-modular-carousel-previous': {
    borderRadius: '4px 0 0 4px',
  },
  'li.kuiper-modular-carousel-next': {
    borderRadius: '0 4px 4px 0',
  },
})

const arrowsWrapper: CSSObject = {
  padding: 0,
  margin: 0,
  listStyleType: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  li: {
    height: '36px',
    width: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.kuiper-light-theme': {
      backgroundColor: colors.n7.base,
      '&:not(.kuiper-disabled)': {
        cursor: 'pointer',
        '.kuiper-icon-arrow-w, .kuiper-icon-arrow-e': {
          color: colors.n3.base,
        },
        '&:hover': {
          '.kuiper-icon-arrow-w, .kuiper-icon-arrow-e': {
            color: colors.white.base,
          },
        },
        '&:active': {
          '.kuiper-icon-arrow-w, .kuiper-icon-arrow-e': {
            color: colors.n5.base,
          },
        },
      },
      '&.kuiper-disabled': {
        cursor: 'default',
        '.kuiper-icon-arrow-w, .kuiper-icon-arrow-e': {
          color: colors.n5.base,
        },
      },
    },
    '&.kuiper-dark-theme': {
      backgroundColor: colors.n3.base,
      '&:not(.kuiper-disabled)': {
        cursor: 'pointer',
        '.kuiper-icon-arrow-w, .kuiper-icon-arrow-e': {
          color: colors.n6.base,
        },
        '&:hover': {
          '.kuiper-icon-arrow-w, .kuiper-icon-arrow-e': {
            color: colors.white.base,
          },
        },
        '&:active': {
          '.kuiper-icon-arrow-w, .kuiper-icon-arrow-e': {
            color: colors.n8.base,
          },
        },
      },
      '&.kuiper-disabled': {
        cursor: 'default',
        '.kuiper-icon-arrow-w, .kuiper-icon-arrow-e': {
          color: colors.n4.base,
        },
      },
    },
  },
}

const centerSlide = (width: number): Record<string, CSSObject> => ({
  left: {
    animation: `${animations.slideLeft(width)} 0.5s ease`,
  },
  right: {
    animation: `${animations.slideRight(width)} 0.5s ease`,
  },
  'new-left': {
    animation: `${animations.slideLeft(width)} 0.5s ease`,
  },
  none: {},
})

const getCenterCarouselSection = (
  width: number,
  shouldScroll?: string,
  override?: CSSObject
): CSSObject => ({
  position: 'absolute',
  ...(shouldScroll ? centerSlide(width)[shouldScroll] : {}),
  ...override,
})

const getLeftCarouselSection = (
  width: number,
  readOnly: boolean,
  isAnimated?: boolean,
  override?: CSSObject
): CSSObject => ({
  animation: isAnimated ? `${animations.slideRight(width)} 0.5s ease` : 'none',
  display: isAnimated ? 'block' : 'none',
  left: `-${width}px`,
  position: 'absolute',
  top: readOnly ? '52px' : '34px',
  zIndex: 10,
  ...override,
})

const getRightCarouselSection = (
  width: number,
  readOnly: boolean,
  isAnimated?: boolean,
  override?: CSSObject
): CSSObject => ({
  animation: isAnimated ? `${animations.slideLeft(width)} 0.5s ease` : 'none',
  display: isAnimated ? 'block' : 'none',
  left: `${width}px`,
  position: 'absolute',
  top: readOnly ? '52px' : '34px',
  zIndex: 10,
  ...override,
})

const scrollWrapper: CSSObject = {
  listStyle: 'none',
}

type ViewportProps = {
  width: number
  isAnimated?: boolean
}

const getViewport = ({ width, isAnimated }: ViewportProps): CSSObject => ({
  height: '100%',
  left: '55px',
  overflow: 'hidden',
  position: 'absolute',
  width: isAnimated ? `${width}px` : `calc(${width}px + 56px)`,
})

const getAnimationViewPort = (
  override?: CSSObject,
  activeOverride?: CSSObject
): CSSObject => ({
  ...override,
  ...activeOverride,
})

const styles = {
  arrowsWrapper,
  getAnimationViewPort,
  getArrowIconsWrapper,
  getCenterCarouselSection,
  getLeftCarouselSection,
  getRightCarouselSection,
  getViewport,
  scrollWrapper,
}

export { styles }
